/* eslint-disable react-hooks/exhaustive-deps */
import {
    ArrowBack,
    CheckCircle,
    Delete,
    DoneAll,
    DriveFileMoveRounded,
    FileDownloadOutlined,
    FileUploadOutlined,
    Mail,
    PlayCircle,
    Send,
    Settings,
} from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid, Tooltip } from "@mui/material";
import {
    GridActionsCellItem,
    GridRowId,
    GridRowModel,
    GridRowSelectionModel,
    GridSortModel,
    GridSortDirection,
} from "@mui/x-data-grid";
import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import DialogInfo from "@/components/informationDialog";
import Actions from "../utils/actions";
import { Container } from "@/theme/globalStyles";
import DataTable from "../../../components/dataTable";
import serviceRebalance from "@/services/serviceRebalanceUsinaInstalacao";
import { useAuth } from "../../../context/global";
import { useHistory } from "react-router-dom";
import messages from "../../../utils/messages";

const RebalanceDetalhar: React.FC = (props: any) => {
    const { setTitlePage } = useAuth();
    const history = useHistory();
    const filterOld = props.location.state.filterOld || "";

    useEffect(() => {
        setTitlePage("Detalhar");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [linesSelecteds, setLinesSelecteds] = useState<GridRowSelectionModel>([]);
    const [disabledDelete, setDisabledDelete] = useState<boolean>(true);
    const [reOpenBlock, setreOpenBlock] = useState<boolean>(false);
    const [AprovConcBlock, setAprovConcBlock] = useState<boolean>(false);
    const [dataMessages, setDataMessages] = useState<string[]>([]);
    const [infoModal, setInfoModal] = useState(false);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    useEffect(() => {
        if (props.location.state.status) {
            const value = ["Aberto", "Processado", "A iniciar"].includes(props.location.state.status);
            setDisabledDelete(value);
        }
    }, [props.location.state.status]);

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operação",
                field: "operations",
                type: "actions",
                width: 140,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Excluir">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        onClick={async () => {
                            const res = await Actions.serviceDelete(params.id);
                            if (res) {
                                getAllWithFilters(props.location.state);
                            }
                        }}
                        disabled={!disabledDelete}
                    />,
                ],
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "rebalanceUsinaInstalacaoID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "UC",
                field: "numeroInstalacao",
                type: "string",
                width: 180,
            },
            {
                headerName: "Nome",
                field: "nomeCliente",
                type: "string",
                width: 260,
            },
            {
                headerName: "Cod. Cliente",
                field: "codigoCliente",
                type: "string",
                width: 190,
            },
            {
                headerName: "Classe",
                field: "classeInstalacao",
                type: "string",
                width: 100,
            },
            {
                headerName: "Disp",
                field: "disponibilidade",
                type: "string",
                width: 100,
            },
            {
                headerName: "Usina",
                field: "nomeUsina",
                type: "string",
                width: 190,
            },
            {
                headerName: "Mês de Ref.",
                field: "mesReferencia",
                type: "string",
                width: 100,
            },
            {
                headerName: "Inj. Prevista",
                field: "injecaoPrevista",
                type: "number",
                width: 120,
            },
            {
                headerName: "Inj. Realizada",
                field: "injecaoRealizada",
                type: "number",
                width: 120,
            },
            {
                headerName: "Saldo Cons. Anterior",
                field: "saldoConsolidadoAnterior",
                type: "number",
                width: 180,
            },
            {
                headerName: "Saldo Cons. Atual",
                field: "saldoConsolidadoAtual",
                type: "number",
                width: 180,
            },
            {
                headerName: "Saldo não pago anterior",
                field: "saldoAlsolAnterior",
                type: "number",
                width: 180,
            },
            {
                headerName: "Saldo não pago atual",
                field: "saldoAlsolAtual",
                type: "number",
                width: 180,
            },
            {
                headerName: "Saldo Conc. Anterior",
                field: "saldoConcessionariaAnterior",
                type: "number",
                width: 180,
            },
            {
                headerName: "Saldo Conc. Atual",
                field: "saldoConcessionariaAtual",
                type: "number",
                width: 180,
            },

            {
                headerName: "Saldo outros anterior",
                field: "saldoOutrosAnterior",
                type: "number",
                width: 190,
            },
            {
                headerName: "Saldo outros atual",
                field: "saldoOutrosAtual",
                type: "number",
                width: 190,
            },
            {
                headerName: "Parceiro",
                field: "nomeParceiro",
                type: "string",
                width: 140,
            },

            {
                headerName: "Cota contrat.",
                field: "cotaContratada",
                type: "number",
                width: 150,
            },
            {
                headerName: "% mínimo cota",
                field: "percentualMinimoCota",
                type: "number",
                width: 150,
            },
            {
                headerName: "% máximo cota",
                field: "percentualMaximoCota",
                type: "number",
                width: 150,
            },
            {
                headerName: "Ajuste Manual",
                field: "ajusteManual",
                type: "number",
                width: 150,
            },
            {
                headerName: "injeção fixa",
                field: "injecaoFixa",
                type: "number",
                width: 150,
            },
            {
                headerName: "Tipo injeção Fixa calc.",
                field: "tipoInjecaoFixaCalculada",
                type: "string",
                width: 190,
            },
            {
                headerName: "Status Fatura Prev.",
                field: "statusFaturaPrevista",
                type: "string",
                width: 150,
            },
            {
                headerName: "Média consumo",
                field: "mediaConsumo",
                type: "number",
                width: 190,
            },
            {
                headerName: "Cota kWh",
                field: "cotaKwh",
                type: "number",
                width: 150,
            },
            {
                headerName: "Perc. saldo sobre cota",
                field: "percentualSaldoSobreCota",
                type: "number",
                width: 190,
            },
            {
                headerName: "Perc. media cons. sobre cota",
                field: "percentualMediaConsumoSobreCota",
                type: "number",
                width: 190,
            },
            {
                headerName: "Prev. Consumo M1",
                field: "previsaoConsumoM1",
                type: "number",
                width: 150,
            },
            {
                headerName: "Prev. Consumo M2",
                field: "previsaoConsumoM2",
                type: "number",
                width: 150,
            },
            {
                headerName: "Saldo Rebalance Atual",
                field: "saldoRebalanceAtual",
                type: "number",
                width: 150,
            },
            {
                headerName: "Cota kWh calculada",
                field: "cotaKwhCalculada",
                type: "number",
                width: 150,
            },
            {
                headerName: "Cota 50% Disp.",
                field: "cota50Disponibilidade",
                type: "number",
                width: 150,
            },
            {
                headerName: "Prev Consumo",
                field: "previsaoConsumo",
                type: "number",
                width: 150,
            },
            {
                headerName: "Prev Con. Disp.",
                field: "previsaoConsumoDisponibilidade",
                type: "number",
                width: 150,
            },
            {
                headerName: "Saldo 50% cota",
                field: "saldo50Cota",
                type: "number",
                width: 150,
            },
            {
                headerName: "Saldo 50% cons",
                field: "saldo50Consumo",
                type: "number",
                width: 150,
            },
            {
                headerName: "Redução",
                field: "reducao",
                type: "number",
                width: 150,
            },
            {
                headerName: "Acréscimo",
                field: "acrescimo",
                type: "number",
                width: 150,
            },
            {
                headerName: "Injeção",
                field: "injecao",
                type: "number",
                width: 150,
            },
            {
                headerName: "Injeção trava",
                field: "injecaoTrava",
                type: "number",
                width: 150,
            },
            {
                headerName: "Trava",
                field: "trava",
                type: "string",
                width: 70,
            },
            {
                headerName: "Ajuste",
                field: "ajuste",
                type: "number",
                width: 100,
            },
            {
                headerName: "Nova cota",
                field: "novaCota",
                type: "number",
                width: 100,
            },
            {
                headerName: "Per. Dist. Ajustada",
                field: "percentualDistribuidoraAjustado",
                type: "number",
                width: 150,
            },
            {
                headerName: "Dif. Previsão Saldo",
                field: "diferencaPrevisaoSaldo",
                type: "number",
                width: 150,
            },

            {
                headerName: "Dif. Saldo",
                field: "diferencaSaldo",
                type: "number",
                width: 150,
            },
            {
                headerName: "Dif. Percentual",
                field: "diferencaPercentual",
                type: "number",
                width: 150,
            },
            {
                headerName: "Dif. Cota",
                field: "diferencaCota",
                type: "number",
                width: 150,
            },

            {
                headerName: "Perf. saldo atual",
                field: "percentualSaldoAtual",
                type: "number",
                width: 190,
            },
            {
                headerName: "Perf. diferença cota",
                field: "percentualDiferencaCota",
                type: "number",
                width: 190,
            },
            {
                headerName: "Perf. diferença cota e saldo",
                field: "percentualDiferencaCotaSaldo",
                type: "number",
                width: 190,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceRebalance
            .getWithFilter({
                rebalanceUsinaID: filters.rebalanceUsinaID,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                if (result) {
                    setData(result?.data.content);
                    setRowCount(result?.data.numberOfElements);
                }
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(props.location.state);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    useEffect(() => {
        if (props && props.location && props.location.state) {
            getAllWithFilters(props.location.state);
        }
    }, [props]);

    useEffect(() => {
        if (dataMessages.length > 0) {
            setInfoModal(true);
        }
    }, [dataMessages]);

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <Grid container spacing={2}>
                            <Grid item md={12}>
                                <Grid container spacing={2}>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="text"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<ArrowBack />}
                                            onClick={() => {
                                                const newArray = filterOld.usinasIds
                                                    ? Array.isArray(filterOld.usinasIds)
                                                        ? filterOld.usinasIds
                                                        : filterOld.usinasIds.split(",")
                                                    : "";

                                                history.push("/rebalance/rebalance", {
                                                    ...filterOld,
                                                    usinasIds: newArray,
                                                });
                                            }}
                                        >
                                            Voltar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<PlayCircle />}
                                            onClick={() => {
                                                Actions.serviceStart(
                                                    props.location.state.usinaID.toString(),
                                                    props.location.state.filterOld.cicloFaturamento
                                                );
                                            }}
                                            disabled={
                                                props.location.state.usinaID &&
                                                props.location.state.status !== "A iniciar" &&
                                                props.location.state.status !== "Sem Movimento"
                                            }
                                        >
                                            Iniciar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<FileDownloadOutlined />}
                                            onClick={() => {
                                                Actions.serviceDownload(
                                                    props.location.state.usinaID.toString(),
                                                    props.location.state.filterOld.cicloFaturamento
                                                );
                                            }}
                                            disabled={
                                                props.location.state.usinaID &&
                                                props.location.state.status !== "Aberto" &&
                                                props.location.state.status !== "Erro" &&
                                                props.location.state.status !== "Processado"
                                            }
                                        >
                                            Download
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<FileUploadOutlined />}
                                            onClick={() => {}}
                                            disabled={true}
                                        >
                                            Importar
                                        </Button>
                                    </Grid>

                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Settings />}
                                            onClick={() => {
                                                Actions.serviceProcess(
                                                    props.location.state.usinaID.toString(),
                                                    props.location.state.filterOld.cicloFaturamento
                                                );
                                            }}
                                            disabled={
                                                props.location.state.usinaID &&
                                                props.location.state.status !== "Aberto" &&
                                                props.location.state.status !== "Erro" &&
                                                props.location.state.status !== "Processado"
                                            }
                                        >
                                            processar
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<CheckCircle />}
                                            onClick={() => {
                                                Actions.serviceApprove(
                                                    props.location.state.rebalanceUsinaID.toString()
                                                );
                                            }}
                                            disabled={
                                                props.location.state.usinaID &&
                                                props.location.state.status !== "Processado"
                                            }
                                        >
                                            Aprovar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item md={12}>
                                <Grid container spacing={2}>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<DriveFileMoveRounded />}
                                            onClick={async () => {
                                                const res = await Actions.serviceReopen(
                                                    props.location.state.rebalanceUsinaID.toString()
                                                );
                                                if (res) {
                                                    setreOpenBlock(true);
                                                }
                                            }}
                                            disabled={
                                                (props.location.state.usinaID &&
                                                    props.location.state.status !== "Aprovado" &&
                                                    props.location.state.status !== "Enviado Concessionária") ||
                                                reOpenBlock
                                            }
                                        >
                                            Reabrir
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Mail />}
                                            onClick={async () => {
                                                const res = await Actions.serviceSendConcessionaria(
                                                    props.location.state.usinaID.toString(),
                                                    props.location.state.filterOld.cicloFaturamento
                                                );
                                                if (res) {
                                                    getAllWithFilters(props.location.state);
                                                }
                                            }}
                                            disabled={
                                                props.location.state.usinaID &&
                                                props.location.state.status !== "Aprovado" &&
                                                props.location.state.status !== "Enviado Concessionária"
                                            }
                                        >
                                            Enviar Con.
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Send />}
                                            onClick={async () => {
                                                const res = await Actions.serviceSankhya(
                                                    props.location.state.usinaID.toString(),
                                                    props.location.state.filterOld.cicloFaturamento
                                                );
                                                if (res) {
                                                    getAllWithFilters(props.location.state);
                                                }
                                            }}
                                            disabled={
                                                props.location.state.usinaID &&
                                                props.location.state.status !== "Enviado Concessionária"
                                            }
                                        >
                                            Sankhya
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<DoneAll />}
                                            onClick={async () => {
                                                const res = await Actions.serviceApproveConcessionaria(
                                                    props.location.state.rebalanceUsinaID.toString()
                                                );
                                                if (res) {
                                                    if (res.data.avisos && res.data.avisos.length > 0) {
                                                        setDataMessages(res.data.avisos);
                                                    } else {
                                                        setAprovConcBlock(true);
                                                        toast.success(
                                                            "Rebalance aprovado concessionária com sucesso para a(s) usina(s) selecionada(s)."
                                                        );
                                                    }
                                                }
                                            }}
                                            disabled={
                                                (props.location.state.usinaID &&
                                                    props.location.state.status !== "Enviado Sankhya") ||
                                                AprovConcBlock
                                            }
                                        >
                                            Aprov. Con
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ margin: "16px 0px 8px 0px" }}
                                            startIcon={<Delete />}
                                            onClick={async () => {
                                                const status = props.location.state.statu;
                                                const res = await Actions.serviceDeleteMany(linesSelecteds, status);
                                                if (res) {
                                                    getAllWithFilters(props.location.state);
                                                }
                                            }}
                                            disabled={linesSelecteds.length <= 0 || !disabledDelete}
                                        >
                                            Delete
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.rebalanceUsinaInstalacaoID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            checkboxSelection
                            onRowSelectionModelChange={(newSelectionModel) => {
                                setLinesSelecteds(newSelectionModel);
                            }}
                            rowSelectionModel={linesSelecteds}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>
                </CardContent>

                {infoModal && (
                    <DialogInfo
                        data={dataMessages}
                        onClose={() => {
                            setInfoModal(false);
                            setDataMessages([]);
                        }}
                    />
                )}
            </Card>
        </Container>
    );
};

export default RebalanceDetalhar;
